import GrupoService from "@/services/GrupoProdutoService"

export const actions = {
    cadastrarGrupoProduto: ({commit, dispatch}) => {
        commit('setGrupoProduto', {
            grupo: ''
        })

        dispatch('setModalCadastroGrupoProduto', true)
    },
    listarGruposProduto: ({commit}) => {
        commit('setOverlay', true)
        GrupoService.listar()
        .then(res => {
            commit('setOverlay', false)
            commit('setGruposProduto', res.data)
        })
        .catch(e => {
            console.log(e)
            commit('setOverlay', false)
        })
    },
    visualizarGrupoProduto: ({commit, dispatch}, id) => {
        commit('setOverlay', true)
        GrupoService.editar(id)
        .then(res => {
            commit('setGrupoProduto', res.data)
            commit('setOverlay', false)
            dispatch('setModalCadastroGrupoProduto', true)
        })
        .catch(e => {
            console.log(e)
            commit('setOverlay', false)

        })
    },
    salvarGrupoProduto: ({commit, dispatch}, data) => {
        dispatch('setModalCadastroGrupoProduto', false)
        commit('setOverlay', true)
        GrupoService.salvar(data)
        .then(res => {
            dispatch('listarGruposProduto')
            dispatch('modalCadastroGrupoProduto', false)
            commit('setOverlay', false)
            commit('snackbarSuccess', 'Grupo cadastro.')
        })
        .catch(e => {
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao cadastrar grupo.')
        })
    },
    atualizarGrupoProduto: ({commit, dispatch}, data) => {
        dispatch('setModalCadastroGrupoProduto', false)
        commit('setOverlay', true)
        GrupoService.atualizar(data)
        .then(res => {
            dispatch('listarGruposProduto')
            commit('setOverlay', false)
            commit('snackbarInfo', 'Grupo atualizado.')
        })
        .catch(e => {
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao atualizar grupo.')
        })
    },
    excluirGrupoProduto: ({commit, dispatch}, id) => {
        dispatch('setModalCadastroGrupoProduto', false)
        commit('setOverlay', true)
        GrupoService.atualizar(id)
        .then(res => {
            dispatch('listarGruposProduto')
            commit('setOverlay', false)
            commit('snackbarError', 'Grupo excluído.')
        })
        .catch(e => {
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao excluir grupo.')
        })
    },
    setModalCadastroGrupoProduto: ({commit}, status) => {
        commit('setModalCadastroGrupoProduto', false)
        setTimeout(() => {
            commit('setModalCadastroGrupoProduto', status) 
        }, 100)
    },
    setModalExcluirGrupoProduto: ({commit}, status) => {
        commit('setModalExcluirGrupoProduto', false)
        setTimeout(() => {
            commit('setModalExcluirGrupoProduto', status) 
        }, 100)
    }
    
}


export default {}